import { useTranslation } from "react-i18next"
import { observer } from "mobx-react-lite"
import { PodClass } from "../../../classes/Pod"
import { iAnnotation } from "../../../shared/src/types/Interaction"

import Link from "../../Elements/Link"
import UxIcon from "../../Elements/UxIcon"
import { Box } from "@mui/material"


const NotesPreview = ({pod}: {pod: PodClass}) => {
  const { t } = useTranslation()
  const notes= pod.getAllNotes()

  const Note = observer(({note}: {note: iAnnotation}) => (
    <Link noDecoration={true} to={`/pod/${pod.podId}/pdf/${note.anchor.nodeId}/annotation/${note.interactionId}`}>
      <Box sx={{
        alignItems: "center",
        backgroundColor: "#ffea77",
        border: "1px solid #9b0a0a",
        borderRadius: "5px",
        color: "textcolor.main",
        display: "grid",
        fontSize: "0.98rem",
        gridTemplateColumns: "auto min-content",
        maxWidth: "600px",
        padding: "15px",
        "&:hover": {
          borderColor: "primary.dark",
          color: "primary.dark"
        }
      }}>
        <Box sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }}>
          {note.label}
        </Box>
        <UxIcon fontSize="small" id="reply" sx={{
          color: "primary.dark",
          margin: "0 10px 0 25px"
        }} />
      </Box>

    </Link>
  ))

  return (
    <Box sx={{
      display: "grid",
      gap: "15px",
      margin: "15px 30px 30px 30px",
      wordBreak: "break-word"
    }}>
      {notes.length === 0 ?
        <Box sx={{
          display: "grid",
          fontSize: "17px",
          fontStyle: "italic",
          fontWeight: 300,
          justifyContent: "center",
          padding: "8px",
          margin: "30px"
        }}>
          {t('No Notes yet')}
        </Box>
        :
        <>
        {notes.slice(0,4).map(note =>
          <Note key={note.interactionId} note={note} />
        )}
        </>
      }
    </Box>
  )
}

export default observer(NotesPreview)